<template>
    <div
        at-t-card
        class="t-card card"
    >
        <template v-if="isShowForm">
            <OCardForm
                :token="token"
                :is-disabled="isDisabled"
                :is-card-holder-name-required="isCardHolderNameRequired"
                @onSubmit="onSubmit"
            />
        </template>
        <transition name="fade">
            <OPaymentProceedForm
                v-if="isShowPaymentProceedForm"
                :token="token"
                :status="status"
                :payment-proceed-form-data="paymentProceedFormData"
                @changeIframeState="handleChangeIframeState"
            />
        </transition>
    </div>
</template>

<script>
import OCardForm from '../../organisms/o-card-form/o-card-form';
import OPaymentProceedForm from '../../unique-organisms/o-payment-proceed-form';

import { CARD_STATUS } from '../../../utils/constants/status-constants';

export default {
    name: 'TCard',
    components: {
        OCardForm,
        OPaymentProceedForm
    },
    props: {
        /**
         * Token
         */
        token: {
            type: String,
            default: ''
        },
        /**
         * Set status
         */
        status: {
            type: String,
            default: ''
        },
        /**
         * Flag for disable sending form
         */
        isDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Flag for show payment proceed form
         */
        isShowPaymentProceedForm: {
            type: Boolean,
            default: false
        },
        /**
         * Flag for show card holder name
         */
        isCardHolderNameRequired: {
            type: Boolean,
            default: false
        },
        /**
         * Payment proceed form data
         * @property action { String }
         * @property method { String }
         * @property params { Object }
         */
        paymentProceedFormData: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        isShowForm() {
            return this.status === CARD_STATUS.NEW
        }
    },
    methods: {
        onSubmit(formData) {
            this.$emit('onSubmit', formData);
        },
        handleChangeIframeState() {
            this.$emit('changeIframeState');
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
